import { useCacheApi } from "../api/CacheApiClient";
import { CacheFrontendService } from "../services/CacheFrontendService";

export const useCacheService = (): CacheFrontendService =>
  new CacheFrontendService(useCacheApi());
